import { useMemo } from 'react'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { usePage } from '@/components/providers/PageProvider'
import { getManaCurveData } from '@/utils/chartUtil'
import { createDynamicComponent } from '@/utils/factoryUtil'

import styles from './ChartsManaCurve.module.scss'

const ChartsManaCurveGraph = createDynamicComponent({
  loader: () => import('./ChartsManaCurveGraph/ChartsManaCurveGraph'),
  name: 'ChartsManaCurveGraph',
})

export const ChartsManaCurve = () => {
  const { page } = usePage()
  const { loading } = useBreakpoints()
  const manaCurve = page?.charts?.manaCurve

  const data = useMemo(() => getManaCurveData({ manaCurve }), [manaCurve])

  if (data.length < 1) return null

  return (
    <div className={styles.container}>
      <div className={styles.chart}>{!loading && <ChartsManaCurveGraph data={data} />}</div>
    </div>
  )
}
